const state = {
    IsLoading: false,
    Enable : true

}

const getters = {
    IsEnable:state=> {
       return state.Enable
    }
}

const actions = {
    Loading({ commit }) {
        commit('SetLoading', true)
    },
    Loaded({ commit }) {
        commit('SetLoading', false)
    },
    Enable({commit}){
        commit('SetEnable',true)
    },
    Disable({commit}){
        commit('SetLoading', false)
        commit('SetEnable',false)
    }
}

const mutations = {
    SetLoading(state, loading) {
        state.IsLoading = loading
    },
    SetEnable(state,enable){
        state.Enable = enable
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js